import { render, staticRenderFns } from "./Insurer.vue?vue&type=template&id=0fe12e9f&scoped=true&"
import script from "./Insurer.vue?vue&type=script&lang=js&"
export * from "./Insurer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe12e9f",
  null
  
)

export default component.exports